import { render, staticRenderFns } from "./QueryClaim.vue?vue&type=template&id=78e8fdfd&scoped=true&"
import script from "./QueryClaim.vue?vue&type=script&lang=ts&"
export * from "./QueryClaim.vue?vue&type=script&lang=ts&"
import style0 from "./QueryClaim.vue?vue&type=style&index=0&id=78e8fdfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e8fdfd",
  null
  
)

export default component.exports